import { useNavigate } from "react-router-dom";

const OtherQuoteCard = (props) => {
  const navigation = useNavigate();

  const renderRenewButton = (item) => {
    return (
      <>
        {(item?.neft_received === "No" || item?.neft_received === "") &&
          item?.renewal_status?.toLowerCase() === "quote confirm" ? (
          <button
            className={`btn btn-sm btn-primary mt-2 fs-7`}
            onClick={() => {
              props.handleGetSource(item);
            }}
          >
            Pending NEFT Details
          </button>
        ) : item?.renewal_status?.toLowerCase() != "quote confirm" && item?.renewal_status?.toLowerCase() != "pending" ? (
          <button className="btn btn-sm btn-primary mt-2 fs-7" disabled>
            {item?.renewal_status}
          </button>
        ) : (
          <button
            className={`btn btn-sm btn-primary mt-2 fs-7`}
            onClick={() =>
              navigation(`/quotes_list/${"" + props.detail.id}`, {
                state: { policyData: props.detail, from: "quote" },
              })
            }
          >
            View Quotes
          </button>
        )}
      </>
    );
  };

  return (
    <>
      <div className="card policy-card mb-5 border">
        <div className="card-header ">
          <div className="row ">
            <div className="col-md-6 mt-2 mt-md-0">
              <span className="ms-auto fw-600 card-title d-flex mb-0">
                <label className="card-label">Quote Type : </label>
                <p className="text-primary ms-1 mb-0">{props.detail.quote_type}</p>
              </span>
            </div>
            <div className="col-md-6 text-right mt-2 mt-md-0">
              <div className="d-flex justify-content-end">
                {/* <label className="card-label">Quote No: </label>
                <p className="card-value mb-0"> {props.detail.id}</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="card-body pointer">
          <div className="row">
            <div class="col-12 col-md-4 mb-2">
              {/* <label class="card-label ">Insured Name:</label> */}
              <label class="card-label ">User Name :</label>
              <p className="card-value mb-0">{props.detail.insured_name}</p>
            </div>
            <div class="col-12 col-md-4 mb-2">
              <label className="card-label my-auto">
                Insurer Name:
                <p className="card-value mb-0 my-auto">
                  {" "}
                  {props.detail?.previous_insurer
                    ? props.detail?.previous_insurer
                    : "-"}
                </p>
              </label>
            </div>
            <div className="col-12 col-md-4 mb-2">
              <label class="card-label">Make & Model</label>
              <p className="card-value mb-0">
                {props?.detail?.make &&
                  props?.detail?.model &&
                  props?.detail?.variant
                  ? `${props.detail.make} - ${props.detail.model} - ${props?.detail?.variant}`
                  : props?.detail?.make && props?.detail?.model
                    ? `${props.detail.make} - ${props.detail.model}`
                    : "-"}
              </p>
            </div>
            {/* <div className="col-12 col-md-4 mb-2">
              <label class="card-label">variant</label>
              <p className="card-value mb-0">
                {props?.detail?.variant ? props?.detail?.variant : "-" }
              </p>
            </div> */}
            <div className="col-12 col-md-4 mb-2">
              <label className="card-label"> Fuel type:</label>
              <p className="card-value mb-0">
                {props?.detail?.fuel_type && props?.detail?.fuel_type}
              </p>
            </div>
            <div className="col-12 col-md-4">
              {renderRenewButton(props?.detail)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtherQuoteCard;
